import { useReveal } from "@hooks/useReveal";
import { useTranslation } from "react-i18next";

import { BrandLogos } from "./BrandLogos";
import styles from "./TrustStrip.module.scss";

type Method = { logo: string; label: string };

export function TrustStrip() {
  const { t } = useTranslation();
  const ref = useReveal();
  const methods = t("trustStrip.methods", { returnObjects: true }) as Method[];
  const caps = t("trustStrip.caps", { returnObjects: true }) as string[];
  const m2 = [...methods, ...methods];
  const c2 = [...caps, ...caps];

  return (
    <section ref={ref} className={`section tight ${styles.tsSection} ${styles.section}`}>
      <div className="container">
        <div className={`reveal ${styles.header}`}>
          <p className={styles.headerEyebrow}>{t("trustStrip.eyebrow")}</p>
          <p className={styles.headerSub}>{t("trustStrip.subtitle")}</p>
        </div>

        <div className={`reveal ${styles.tsMarquee}`}>
          <div className={`${styles.tsRow} ${styles.tsRowL}`}>
            {m2.map((m, i) => {
              const Logo = BrandLogos[m.logo];
              return (
                <div key={`r1-${i}`} className={styles.tsChip}>
                  {Logo ? (
                    <Logo />
                  ) : (
                    <>
                      <span className={styles.tsDot} />
                      <span className={styles.tsChipText}>{m.label}</span>
                    </>
                  )}
                </div>
              );
            })}
          </div>
          <div className={`${styles.tsRow} ${styles.tsRowR}`}>
            {c2.map((c, i) => (
              <div key={`r2-${i}`} className={`${styles.tsChip} ${styles.tsChipCap}`}>
                <span className={styles.tsCheck} aria-hidden="true">
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12l4 4L19 6" />
                  </svg>
                </span>
                <span>{c}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
